// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e5179465","455":"582cfb4e","977":"b0695b59"}[chunkId] + ".chunk.js";
};